import { RandomId } from "@swivl-mono/helpers";
import { LoadDataLoaders, NodeData_LoadData, NodeInterface, NodeType } from "@swivl-mono/types";
import { Select } from "@swivl-mono/ui";

import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const LoadData = {
  Type: NodeType.LoadData,
  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.LoadData,

      loader: LoadDataLoaders.NearbyLocationsAndUnits,
      params: {},
      goto: "",
      onErrorGoto: ""
    } as NodeData_LoadData;
  },

  PlumbData: function (node: NodeInterface) {
    return TabNodeLayoutData({
      node: node,
      label: "Load Data",
      body: node.loader,
      baseWidth: 150,
      tabs: [
        {
          id: "goto",
          source: "goto",
          target: node.goto,
          title: "Loaded"
        },
        {
          id: "onErrorGoto",
          source: "onErrorGoto",
          target: node.onErrorGoto,
          title: "Error"
        }
      ]
    });
  },

  InspectorPanel: class LoadDataInspectorPanel extends NodePanel {
    render() {
      const { node } = this.props;

      return (
        <div className="panel save_panel">
          <InspectorNodeHeader title="Load Data" id={this.props.node.id} />
          <Select
            label="Select a loader"
            options={[{ value: LoadDataLoaders.NearbyLocationsAndUnits, label: "Nearby Locations and Units" }]}
            selectedValues={[node.loader || ""]}
            hideClear
            onChange={(vals) => this.onChangeSwitch("loader", vals[0])}
          />

          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default LoadData;
